import axios from "axios";

export const contactData = () => {
  return axios
    .get("/settings")
    .then((response) => {
      // console.log(response.data);
      return response;
    });
};